import { render, staticRenderFns } from "./PostEvidenceCard.vue?vue&type=template&id=61da0661&scoped=true&"
import script from "./PostEvidenceCard.vue?vue&type=script&lang=js&"
export * from "./PostEvidenceCard.vue?vue&type=script&lang=js&"
import style0 from "./PostEvidenceCard.vue?vue&type=style&index=0&id=61da0661&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61da0661",
  null
  
)

export default component.exports